<template>
	<div>
		<app-header></app-header>
        <div v-show="isLoading" align="center" class="mt-7">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>
        <div v-show="!isLoading">
          <v-container fluid grid-list-xl class="mt-7">
            <v-layout row wrap>
              <v-flex xs12 md12 lg12 sm12 class="col-height-auto">
                <div class="app-card">
                <v-data-table :headers="headers" :items="transactionList" class="elevation-3" hide-actions> 
                  <template slot="items" slot-scope="props">
                    <td class="text-xs-left">
                      <a @click="goTransactionData(props.item)">
                        {{ (props.item.hash.length) > 18 ? (props.item.hash).substring(0,18) + '...' : (props.item.hash) }}
                      </a>
                    </td>
                    <td class="text-xs-left">
                      <span>
                        {{ timeStampToTime(props.item.timeStamp) }}
                      </span>
                    </td>
                    <td class="text-xs-left">
                      <a>
                        {{ (props.item.from.length) > 18 ? (props.item.from).substring(0,18) + '...' : (props.item.from) }}
                      </a>
                    </td>
                    <td class="text-xs-left">
                      <a>
                        {{ subToHash(props.item.input) }}
                      </a>
                    </td>
                    <td class="text-xs-left">
                      <span>
                        {{ getQuantity(props.item.input) }}
                      </span>
                    </td>
                  </template>
                  <!-- <template slot="footer">
                    <td colspan="" class="text-xs-center">
                      <template>
                      <div class="text-xs-center">
                        <v-pagination v-model="pageNo" :length="totalPage" :total-visible="7" circle color="primary" next="a"></v-pagination>
                      </div>
                    </template>
                    </td>
                  </template> -->
              </v-data-table>
              </div>
              </v-flex>
            </v-layout>
          </v-container>
          <div class="mt-3 mb-5 text-xs-center">
            <Page :total="totalTransactionNumber" :pageSize="pageSize" simple  @on-change="getTransactionByPage"  ></Page>
          </div>
        </div>
      
<!-- 		<div class="mt-5 text-xs-center">
        <v-data-table :headers="headers" :items="transactionList" class="elevation-1" hide-actions>
            <template slot="items" slot-scope="props">
              <td class="text-xs-left">
                <a @click="goTransactionData(props.item)">
                  {{ (props.item.hash.length) > 18 ? (props.item.hash).substring(0,18) + '...' : (props.item.hash) }}
                </a>
              </td>
              <td class="text-xs-left">
                <span>
                  {{ timeStampToTime(props.item.timeStamp) }}
                </span>
              </td>
              <td class="text-xs-left">
                <a>
                  {{ (props.item.from.length) > 18 ? (props.item.from).substring(0,18) + '...' : (props.item.from) }}
                </a>
              </td>
              <td class="text-xs-left">
                <a>
                  {{ subToHash(props.item.input) }}
                </a>
              </td>
              <td class="text-xs-left">
                <span>
                  {{ getQuantity(props.item.input) }}
                </span>
              </td>
            </template> -->
            <!-- <template slot="footer">
              <td colspan="" class="text-xs-center">
                <template>
                <div class="text-xs-center">
                  <v-pagination v-model="pageNo" :length="totalPage" :total-visible="7" circle color="primary" next="a"></v-pagination>
                </div>
              </template>
              </td>
            </template> -->
     <!--    </v-data-table>
      </div> -->
      
	</div>
</template>

<script>
	import Vue from 'vue'
    import config from '../../config.js'
    export default {
        data(){
            return{
                isLoading: true,                    //是否显示加载中
                headers: [                          //表格头部
                  { text: this.$t('transaction.txHash'), align: 'left', value: 'txHash',sortable: false},
                  { text: this.$t('transaction.date'), align: 'left', value: 'date', sortable: false},
                  { text: this.$t('transaction.from'), align: 'left', value: 'from', sortable: false},
                  { text: this.$t('transaction.to'), align: 'left', value: 'to', sortable: false},
                  { text: this.$t('transaction.quantity'), align: 'left', value: 'quantity', sortable: false}
                ],
                transactionList: [],                //交易列表集合
                totalTransactionNumber: 0,          //总交易数
                pageNo: 1,                          //当前页码
                pageSize: 20,                       //每页显示数量
                totalPage: 1,
                params: [
                  "0xaf29be288274e907f948e148b1e757e29c046cbd",
                  "latest"
                ],
                params2:['0x7f64eae019f8058449d2131d99f1c47e4f153a4897faa6a83f4bc9c2f7b8e865']
            }
        },
        computed: {

        },
        created(){
            
        },
        mounted:function(){
          this.getTransactionList();
        },
        watch:{
            
        },        
        methods: {
            //获得初始化列表数据
            getTransactionList(){
                // var obj = JSON.stringify(this.params);
                // // console.log(obj)
                // this.$http.get("https://api.infura.io/v1/jsonrpc/mainnet/eth_getBalance?params=" + obj).then( successData => {
                //     let data = successData.data;
                //     // console.log(data)
                // });
                // let a = "https://api.infura.io/v1/jsonrpc/mainnet/eth_getTransactionReceipt?params="  + JSON.stringify(this.params2);
                // this.$http.get(a).then( successData => {
                //     let data = successData.data;
                //     // console.log(data)
                // });
                let transactionCountUrl = config.baseUrl + "token/open/getTransactionCount";
                this.$http.get(transactionCountUrl).then( successData => {
                    let data = successData.data;
                    if (data.resCode == 0) {
                        this.totalTransactionNumber = data.result;
                        this.totalPage = Math.ceil(this.totalTransactionNumber/this.pageSize);
                    }
                });
                let url = config.baseUrl + "token/open/getTransactionList/"+this.pageNo+"/"+this.pageSize;
                this.$http.get(url).then( successData => {
                    let data = successData.data;
                    if (data.resCode == 0) {
                        this.transactionList = data.result;
                        this.isLoading = false;
                        this.pageNo = this.pageNo + 1;
                    }
                });
            },
            timeStampToTime(timeStamp){
                return timeStampToTime(timeStamp);
            },
            //截取目标hash值
            subToHash(input){
              let to = '0x' + input.substring(34, 74);
              return (to.length > 18) ? (to.substring(0, 18) + '...') : to;
            },
            //分页查询
            getTransactionByPage(pageNo){
              let url = config.baseUrl + "token/open/getTransactionList/"+pageNo+"/"+this.pageSize;
                this.$http.get(url).then( successData => {
                    let data = successData.data;
                    if (data.resCode == 0) {
                        this.transactionList = data.result;
                        this.pageNo = this.pageNo + 1;
                    }
                });
            },
            //路由到交易详情页面
            goTransactionData(transaction){
              sessionStorage.setItem('transaction', JSON.stringify(transaction));
              this.$router.push({name: 'transactionData',params: {txHash: transaction.hash}});
            },
            //从input中截取出16进制数的数量并进行转换为10进制
            getQuantity(input){
                let sixteen = input.substring(74, 138);
                var ten = parseInt(sixteen,16);
                return ten / 1E18;
            }
        },

    }
</script>


// WEBPACK FOOTER //
// Transaction.vue?670f11fc